@if (showAuthBackground) {
  <div class="auth-background" aria-hidden="true">
    <div class="auth-background__gradient"></div>
    <div class="auth-background__grid"></div>
    <div class="auth-background__blob auth-background__blob--teal"></div>
    <div class="auth-background__blob auth-background__blob--soft"></div>
    <div class="auth-background__brand">
      <img src="assets/img/tidy-logo.svg" alt="" class="auth-background__logo" />
      <div class="auth-background__tagline">For Pros</div>
    </div>
    <div class="auth-background__chips">
      <span class="auth-background__chip">More clients</span>
      <span class="auth-background__chip">Less admin</span>
      <span class="auth-background__chip">Paid faster</span>
    </div>
  </div>
}

<ion-split-pane content-id="main" when="(min-width: 711px)" [class.hidden-behind-auth]="showAuthBackground">
  <ion-menu
    [disabled]="!isAuthenticated"
    [swipeGesture]="false"
    content-id="main"
  >
    <app-desktop-nav *ngIf="isAuthenticated">
    </app-desktop-nav>
  </ion-menu>

  <ion-router-outlet id="main" [swipeGesture]="false" animated="false">

  </ion-router-outlet>

  <ion-modal class="hide"></ion-modal>
</ion-split-pane>

<tidy-translations [translations]="translations"></tidy-translations>
